import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PSAPage = lazy(() => import("./PSAPage"));

const PSAPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PSAPage />
    </Suspense>
  );
};

export default PSAPageLazy;
